










































































































































































































































































import { Component, Vue, Watch, Prop, Ref } from "vue-property-decorator";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import {
  ScheduleModel,
  MessageSchedulingSleepTimeHandlingTypeEnum,
} from "./types";
import { Getter, Action } from "vuex-class";
import { DistributionChannelType } from "@/shared/models/distributionChannelType";
import { Ota } from "@/shared/models/ota";
import { SalesChannelView } from "@/shared/models/salesChannel";
import { ReservationStatus } from "@/shared/models/reservationStatus";
import { DistributionChannelTypesEnum } from "@/components/reservation-form/types";
import { Notification } from "@/store/modules/notifications";
import { NotificationSchedulesOffset } from "@/shared/models/notificationSchedulesOffset";
import {
  NotificationSchedulesTriggerDate,
  NotificationSchedulesTriggerDateEnum,
} from "@/shared/models/notificationSchedulesTriggerDate";
import FormDescription from "@/components/misc/FormDescription.vue";
import * as _ from "lodash";
import { ListModel } from "@/shared/models/listModel";
import { PropertyWithPostalCode } from "@/shared/models/property";
import { PaymentMean } from "@/shared/models/paymentMean";
import { TenantTypesEnum } from "@/shared/models/enums.type";
import { enumToArray } from "@/shared/commonFunctions";

@Component({
  components: {
    RightDrawer,
    FormDescription,
  },
})
export default class NotificationScheduleForm extends Vue {
  @Prop({ default: false }) open!: boolean;
  @Prop({ default: 0 }) templateId?: number;
  @Prop() scheduleId?: number;

  fkey = 0;

  enumToArray = enumToArray;
  messageSchedulingSleepTimeHandlingTypeEnum =
    MessageSchedulingSleepTimeHandlingTypeEnum;

  @Ref("drawer") rightDrawer?: RightDrawer;
  close() {
    this.rightDrawer?.clickOverlay();
  }

  isFormValid = false;

  model = new ScheduleModel();
  initialModel = new ScheduleModel();

  loading = false;

  @Watch("open")
  openWatch(fresh: boolean) {
    if (fresh) {
      this.fkey++;

      if (this.scheduleId) {
        this.loading = true;
        this.axios
          .get<ScheduleModel>("/notificationSchedules/" + this.scheduleId)
          .then((res) => {
            this.model = res.data;
            this.initialModel = _.cloneDeep(this.model);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.model = new ScheduleModel();
        if (this.templateId) {
          this.model.notificationTemplateId = this.templateId;
        }

        this.initialModel = _.cloneDeep(this.model);
      }
    }
  }

  get selected() {
    return this.items.filter((x) =>
      this.model.propertiesIds.includes(x.propertyId)
    );
  }

  set selected(val: PropertyWithPostalCode[]) {
    const selectedIds = val.map((x) => x.propertyId);
    this.model.propertiesIds = [
      ...new Set([...this.model.propertiesIds, ...selectedIds]),
    ];
  }

  nameFilter = "";
  addressFilter = "";
  postalCodeFilter = "";
  selectedOnly = false;
  loadingProperties = true;

  properties: PropertyWithPostalCode[] = [];
  loadProperties() {
    this.loadingProperties = true;
    Vue.axios
      .get<ListModel<PropertyWithPostalCode>>(
        "/properties/PropertiesWithPostalCode",
        {
          params: {
            $count: true,
            $skip: this.properties.length,
            $orderby: "propertyId",
          },
        }
      )
      .then((res) => {
        this.properties.push(...res.data.result);
        if (res.data.count && this.properties.length < res.data.count) {
          this.loadProperties();
        }
      })
      .finally(() => (this.loadingProperties = false));
  }

  get items(): PropertyWithPostalCode[] {
    let items = this.properties ?? [];

    if (this.selectedOnly) {
      items = items.filter((e) =>
        this.selected.some((s) => e.propertyId == s.propertyId)
      );
    }

    return items
      .filter(
        (e) =>
          !this.nameFilter ||
          e.name.toLowerCase().includes(this.nameFilter.toLowerCase())
      )
      .filter(
        (e) =>
          !this.addressFilter ||
          e.address.toLowerCase().includes(this.addressFilter.toLowerCase())
      )
      .filter(
        (e) =>
          !this.postalCodeFilter ||
          e.postalCodeAndCity
            .toLowerCase()
            .includes(this.postalCodeFilter.toLowerCase())
      );
  }

  selectAllProperties(value: boolean) {
    if (value) {
      for (const prop of this.items) {
        if (!this.model.propertiesIds.some((x) => x == prop.propertyId)) {
          this.model.propertiesIds.push(prop.propertyId);
          this.selected.push(prop);
        }
      }
    } else {
      for (const prop of this.items) {
        const index = this.model.propertiesIds.findIndex(
          (x) => x == prop.propertyId
        );

        if (index != -1) {
          this.model.propertiesIds.splice(index, 1);
        }

        const selectedIndex = this.selected.findIndex(
          (x) => x.propertyId == prop.propertyId
        );
        if (selectedIndex != -1) {
          this.selected.splice(selectedIndex, 1);
        }
      }
    }
  }

  selectProperty({
    item,
    value,
  }: {
    item: PropertyWithPostalCode;
    value: boolean;
  }) {
    if (value && !this.model.propertiesIds.some((x) => x == item.propertyId)) {
      this.model.propertiesIds.push(item.propertyId);
    } else if (!value) {
      const index = this.model.propertiesIds.findIndex(
        (x) => x == item.propertyId
      );
      if (index != -1) {
        this.model.propertiesIds.splice(index, 1);
      }
    }
  }

  areAllPropertiesSelected() {
    return !this.items.some(
      (e) =>
        this.model.propertiesIds.findIndex((acc) => acc == e.propertyId) == -1
    );
  }

  headers = [
    {
      text: "Property",
      value: "name",
    },
    {
      text: "Address",
      value: "address",
    },
    {
      text: "City",
      value: "postalCodeAndCity",
    },
  ];

  get translatedHeaders() {
    return this.headers.map((x) => ({ ...x, text: this.$t(x.text) }));
  }

  get isTenantTypeAgency() {
    return this.tenantTypeId === TenantTypesEnum.Agency;
  }

  get allowedDistributionChannelTypes() {
    if (!this.distributionChannelTypes) {
      return [];
    }
    const types = _.cloneDeep(this.distributionChannelTypes);

    if (this.isTenantTypeAgency) {
      return types;
    } else {
      return types?.filter(
        (channel) =>
          channel.id != DistributionChannelTypesEnum.OwnersReservation
      );
    }
  }

  get localSleepTimePeriod() {
    if (!this.messageSchedulingSleepTimePeriod) return undefined;

    const startingDate = new Date();
    startingDate.setUTCHours(
      +this.messageSchedulingSleepTimePeriod.start.split(":")[0],
      +this.messageSchedulingSleepTimePeriod.start.split(":")[1],
      0,
      0
    );

    const endingDate = new Date();
    endingDate.setUTCHours(
      +this.messageSchedulingSleepTimePeriod.end.split(":")[0],
      +this.messageSchedulingSleepTimePeriod.end.split(":")[1],
      0,
      0
    );

    if (endingDate.getTime() < startingDate.getTime()) {
      endingDate.setDate(endingDate.getDate() + 1);
    }

    return {
      start: startingDate,
      end: endingDate,
    };
  }

  @Getter("codebooks/notificationSchedulesOffsets")
  offsets?: NotificationSchedulesOffset[];
  @Action("codebooks/refreshNotificationSchedulesOffsets")
  refreshOffsets?: () => Promise<void>;

  @Getter("codebooks/notificationSchedulesTriggerDates")
  triggerDates?: NotificationSchedulesTriggerDate[];
  @Action("codebooks/refreshNotificationSchedulesTriggerDates")
  refreshTriggerDates?: () => Promise<void>;

  @Action("codebooks/refreshOtas") refreshOtas?: () => Promise<void>;
  @Getter("codebooks/otas") otas?: Ota[];

  @Action("codebooks/refreshSalesChannels")
  refreshSalesChannels?: () => Promise<void>;
  @Getter("codebooks/salesChannels") salesChannels?: SalesChannelView[];

  @Action("codebooks/refreshDistributionChannelTypes")
  refreshDistributionChannelTypes?: () => Promise<void>;
  @Getter("codebooks/distributionChannelTypes")
  distributionChannelTypes?: DistributionChannelType[];

  @Action("codebooks/refreshPaymentMeans")
  refreshPaymentMeans?: () => Promise<void>;
  @Getter("codebooks/paymentMeans")
  paymentMeans?: PaymentMean[];

  @Action("codebooks/refreshReservationStatuses")
  refreshReservationStatuses?: () => Promise<void>;
  @Getter("codebooks/reservationStatuses")
  reservationStatuses?: ReservationStatus[];

  @Getter("appParams/typeId") tenantTypeId?: number;
  @Getter("appParams/messageSchedulingSleepTimePeriod")
  messageSchedulingSleepTimePeriod?: {
    start: string;
    end: string;
  };

  async created() {
    this.loadProperties();

    const promises = [];

    if ((this.offsets?.length ?? 0) === 0 && this.refreshOffsets) {
      promises.push(this.refreshOffsets());
    }

    if ((this.triggerDates?.length ?? 0) === 0 && this.refreshTriggerDates) {
      promises.push(this.refreshTriggerDates());
    }

    if (
      (this.distributionChannelTypes?.length ?? 0) === 0 &&
      this.refreshDistributionChannelTypes
    ) {
      promises.push(this.refreshDistributionChannelTypes());
    }

    if ((this.paymentMeans?.length ?? 0) === 0 && this.refreshPaymentMeans) {
      promises.push(this.refreshPaymentMeans());
    }

    if ((this.otas?.length ?? 0) === 0 && this.refreshOtas) {
      promises.push(this.refreshOtas());
    }

    if ((this.salesChannels?.length ?? 0) === 0 && this.refreshSalesChannels) {
      promises.push(this.refreshSalesChannels());
    }

    if (
      (this.reservationStatuses?.length ?? 0) === 0 &&
      this.refreshReservationStatuses
    ) {
      promises.push(this.refreshReservationStatuses());
    }

    await Promise.all(promises);
  }

  beforeAfter = [
    {
      value: true,
      name: "Before",
    },
    {
      value: false,
      name: "After",
    },
  ];

  DistributionChannelTypesEnum = DistributionChannelTypesEnum;

  get isActive() {
    return !this.model.isDraft;
  }

  set isActive(value) {
    this.model.isDraft = !value;
  }

  get allowedTriggerDates() {
    const notImplementedTriggers = [
      NotificationSchedulesTriggerDateEnum.OfferExpirationDate,
      NotificationSchedulesTriggerDateEnum.InvoiceDueDate,
      NotificationSchedulesTriggerDateEnum.AdvanceInvoicePaymentDate,
      NotificationSchedulesTriggerDateEnum.ReservationPaymentDate,
    ];

    return (
      this.triggerDates?.map((x) => {
        return {
          ...x,
          disabled: notImplementedTriggers.some((e) => e == x.id),
        };
      }) ?? []
    );
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  saving = false;
  submit() {
    this.form.validate();
    if (!this.isFormValid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Changes are invalid or incomplete"),
        timeout: 5000,
      });

      return;
    }

    this.saving = true;

    if (!this.model.id) {
      this.axios
        .post<number>("/notificationSchedules", this.model)
        .then((res) => {
          this.model.id = res.data;
          this.saveSuccess();
          this.$emit("created", this.model.id);
        })
        .finally(() => {
          this.saving = false;
        });
    } else {
      this.axios
        .put("/notificationSchedules", this.model)
        .then(() => {
          this.saveSuccess();
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  saveSuccess() {
    this.$store.dispatch("showNotification", {
      color: "success",
      message: this.$t("NotificationSchedule.SaveSuccess"),
      timeout: 5000,
    } as Notification);

    if (!this.model.isDraft) {
      this.$store.dispatch("showNotification", {
        color: "success",
        message: this.$t("scheduleMessage.ScheduledChangesInfo"),
        timeout: 5000,
      } as Notification);
    }

    this.initialModel = _.cloneDeep(this.model);
  }

  deleteSchedule() {
    this.$store.dispatch("showNotification", {
      id: this.model.id,
      color: "warning",
      message: this.$t("DeleteConfirmation") + ` '${this.model?.name}'`,
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deleteConfirmed();
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }

  deleteConfirmed() {
    if (this.model.id) {
      this.axios.delete("/notificationSchedules/" + this.model.id).then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("NotificationSchedule.DeleteSuccess"),
          timeout: 5000,
        } as Notification);

        this.$emit("deleted");
      });
    }
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      notNull: (value: any) =>
        (value != null && value != undefined) || this.$t("Validation.Required"),
      maxLength: (value: string, max: number) =>
        value.length <= max || this.$t("Validation.MaxLength", { count: max }),
    };
  }
}
